/* eslint-disable react/prop-types */

function CardCircle1(props) {
  const { fillColor } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <defs>
        <clipPath id="clip-path">
          <circle
            id="Ellipse_53"
            data-name="Ellipse 53"
            cx="16"
            cy="16"
            r="16"
            transform="translate(3393.197 8393)"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Group_455" data-name="Group 455" transform="translate(-3393.197 -8393)">
        <g id="Group_454" data-name="Group 454" clipPath="url(#clip-path)">
          <g id="Group_453" data-name="Group 453">
            <path
              id="Path_1827"
              data-name="Path 1827"
              d="M3430.212,8407.379,3428.6,8409l1.611,1.612.127-.126v-2.977Z"
              fill="none"
            />
            <path
              id="Path_1828"
              data-name="Path 1828"
              d="M3430.212,8413.844l-4.845-4.847,4.845-4.847.127.127v-3.229l-.127-.127-8.075,8.075,8.075,8.075.127-.127v-3.229Z"
              fill="none"
            />
            <path
              id="Path_1829"
              data-name="Path 1829"
              d="M3402.756,8389.623l-3.229,3.224-4.493-4.487h-3.229l7.721,7.718,6.459-6.454-1.265-1.264h-3.229Z"
              fill="none"
            />
            <path
              id="Path_1830"
              data-name="Path 1830"
              d="M3418.906,8392.847l-1.618,1.616-6.1-6.1h-3.233l7.721,7.718-6.458,6.463-4.843-4.841,3.226-3.236,1.617,1.614-1.617,1.622,1.617,1.612,3.234-3.234-4.852-4.843-6.459,6.465,8.076,8.069,17.408-17.409H3423.4Z"
              fill="none"
            />
            <path
              id="Path_1831"
              data-name="Path 1831"
              d="M3417.288,8391.234l2.881-2.875h-5.758l1.26,1.264Z"
              fill="none"
            />
            <path
              id="Path_1832"
              data-name="Path 1832"
              d="M3417.642,8429.641h2.528l-1.264-1.263Z"
              fill="none"
            />
            <path
              id="Path_1833"
              data-name="Path 1833"
              d="M3430.212,8420.3l-11.3-11.3,11.3-11.306.127.127v-3.234l-.127-.126L3415.679,8409l14.532,14.534.127-.126v-3.236Z"
              fill="none"
            />
            <path
              id="Path_1834"
              data-name="Path 1834"
              d="M3400.786,8388.359h-2.524l1.265,1.264Z"
              fill="none"
            />
            <path
              id="Path_1835"
              data-name="Path 1835"
              d="M3412.449,8428.378l1.258,1.263h3.227l-1.262-1.263,1.616-1.61,1.618-1.62,4.492,4.493h3.224l-7.716-7.722Z"
              fill="none"
            />
            <path
              id="Path_1836"
              data-name="Path 1836"
              d="M3398.263,8429.641h5.751l-2.875-2.874Z"
              fill="none"
            />
            <path
              id="Path_1837"
              data-name="Path 1837"
              d="M3402.756,8421.919l6.459-6.457,4.845,4.841-3.229,3.234-1.616-1.618,1.616-1.616-1.616-1.612-3.229,3.229,4.845,4.848,6.458-6.464-8.073-8.077-17.41,17.415h3.229l6.1-6.1,6.106,6.1h3.234Z"
              fill="none"
            />
            <path
              id="Path_1838"
              data-name="Path 1838"
              d="M3430.338,8426.634l-.127.126L3412.449,8409l17.763-17.763.127.126v-3h-.48L3409.215,8409l20.643,20.644h.48Z"
              fill="none"
            />
            <path
              id="Path_1839"
              data-name="Path 1839"
              d="M3412.449,8409l17.763,17.763.127-.126v-3.229l-.127.126L3415.679,8409l14.532-14.539.127.126v-3.224l-.127-.126Z"
              fill={fillColor || '#8EA5AB'}
            />
            <path
              id="Path_1840"
              data-name="Path 1840"
              d="M3418.908,8409l11.3,11.3.127-.127v-3.224l-.127.127-8.075-8.075,8.075-8.075.127.127v-3.23l-.127-.127Z"
              fill={fillColor || '#8EA5AB'}
            />
            <path
              id="Path_1841"
              data-name="Path 1841"
              d="M3425.367,8409l4.845,4.847.127-.127v-3.233l-.127.126L3428.6,8409l1.611-1.618.127.128v-3.229l-.127-.127Z"
              fill={fillColor || '#8EA5AB'}
            />
            <path
              id="Path_1842"
              data-name="Path 1842"
              d="M3395.034,8429.641h3.229l2.875-2.874,2.875,2.874h3.23l-6.106-6.1Z"
              fill={fillColor || '#8EA5AB'}
            />
            <path
              id="Path_1843"
              data-name="Path 1843"
              d="M3418.906,8428.378l1.264,1.263h3.229l-4.492-4.493-1.618,1.62-1.616,1.61,1.262,1.263h.708Z"
              fill={fillColor || '#8EA5AB'}
            />
            <path
              id="Path_1844"
              data-name="Path 1844"
              d="M3409.215,8412.226l8.073,8.077-6.458,6.464-4.845-4.848,3.229-3.229,1.616,1.612-1.616,1.616,1.616,1.618,3.229-3.234-4.845-4.841-6.459,6.457,7.722,7.722h3.23l-1.258-1.263,6.457-6.459,7.716,7.722h3.236L3409.215,8409h0l-20.638,20.644h3.229Z"
              fill={fillColor || '#8EA5AB'}
            />
            <path
              id="Path_1845"
              data-name="Path 1845"
              d="M3388.576,8391.588v3.224L3402.76,8409l-14.184,14.184v3.229L3405.989,8409Z"
              fill={fillColor || '#8EA5AB'}
            />
            <path
              id="Path_1846"
              data-name="Path 1846"
              d="M3388.576,8398.045v3.23L3396.3,8409l-7.726,7.725v3.224L3399.531,8409Z"
              fill={fillColor || '#8EA5AB'}
            />
            <path
              id="Path_1847"
              data-name="Path 1847"
              d="M3388.576,8404.5v3.23l1.262,1.266-1.262,1.262v3.233l4.5-4.5Z"
              fill={fillColor || '#8EA5AB'}
            />
            <path
              id="Path_1848"
              data-name="Path 1848"
              d="M3402.756,8389.623l-1.264-1.264h-.706l-1.259,1.264-1.265-1.264h-3.228l4.493,4.487Z"
              fill={fillColor || '#8EA5AB'}
            />
            <path
              id="Path_1849"
              data-name="Path 1849"
              d="M3418.906,8392.847l4.492-4.487h-3.229l-2.881,2.875-1.616-1.611-1.26-1.264h-3.228l6.1,6.1Z"
              fill={fillColor || '#8EA5AB'}
            />
            <path
              id="Path_1850"
              data-name="Path 1850"
              d="M3409.215,8409l20.643-20.638h-3.236l-17.408,17.409-8.076-8.069,6.459-6.465,4.852,4.843-3.234,3.234-1.617-1.612,1.617-1.622-1.617-1.614-3.226,3.236,4.843,4.841,6.458-6.463-7.721-7.718h-3.23l1.265,1.264-6.459,6.454-7.721-7.718h-3.229L3409.215,8409Z"
              fill={fillColor || '#8EA5AB'}
            />
            <path
              id="Path_1851"
              data-name="Path 1851"
              d="M3409.215,8409Z"
              fill={fillColor || '#8EA5AB'}
            />
            <path
              id="Path_1852"
              data-name="Path 1852"
              d="M3417.642,8429.641h-.708l.354.354Z"
              fill={fillColor || '#8EA5AB'}
            />
            <path
              id="Path_1853"
              data-name="Path 1853"
              d="M3401.138,8388.006l-.352.354h.706Z"
              fill={fillColor || '#8EA5AB'}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default CardCircle1;
